import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Esto es moral?',
  a: 'Es más moral saber defenderse que ser una víctima voluntaria.'
}, {
  q: '¿Es difícil de aplicar?',
  a: 'El método se basa en cambios sutiles de lenguaje y silencio que cualquiera puede hacer.'
}, {
  q: '¿Cuánto tiempo tarda en verse el efecto?',
  a: 'El cambio de percepción de los demás hacia ti suele ser inmediato tras aplicar el primer capítulo.'
}, {
  q: '¿Necesito conocimientos previos de psicología?',
  a: 'No, todo está explicado en lenguaje directo y para el mundo real.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-65">
      <div className="text-center mb-16" data-id="element-66">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-foreground" data-id="element-67">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-4" data-id="element-68">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="border border-border bg-darker overflow-hidden" data-id="element-69">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-70">
                <span className="font-serif text-xl font-bold text-foreground" data-id="element-71">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: isOpen ? 45 : 0
            }} transition={{
              duration: 0.2
            }} className="text-blood flex-shrink-0 ml-4" data-id="element-72">
                  <Plus size={24} data-id="element-73" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-74">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-75">
                    <div className="px-6 pb-5 pt-0 text-foreground/70 font-sans font-light leading-relaxed" data-id="element-76">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}